import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=2e77be3e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e77be3e"]])

export default __exports__